import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'edit-event-dialog',
    template: `
      <div class="joi-dialog">
          <div mat-dialog-title>
             Edit Event Name
          </div>
          <div mat-dialog-content>
              <div class="dialog_content">
                  <div class="para">
                      Update your event name:
                  </div>
                  <mat-form-field class="general">
                      <input matInput name="event_name" [(ngModel)]="event_name" placeholder="Event Name">
                  </mat-form-field>
              </div>
          </div>
          <div mat-dialog-actions class="lg">
              <button mat-button (click)="dialogRef.close()">Cancel</button>
              <button mat-button color="primary" [disabled]="!event_name" (click)="updateEvent()">Save</button>
          </div>
      </div>
  `,
    styles: [`
  .joi-dialog .para { margin-bottom: 15px; }
  `],
    standalone: true,
    imports: [MatFormFieldModule, FormsModule]
})
export class EditEventDialogComponent {

  event_name;

  constructor(public dialogRef: MatDialogRef<EditEventDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.event_name = data.event_name;
  }

  updateEvent() {
    this.dialogRef.close({ event_name: this.event_name });
  }
}

export interface EditEventNameData { event_name: string }
